import { render } from "./DraftDrugComposer.vue?vue&type=template&id=26480e26&scoped=true"
import script from "./DraftDrugComposer.vue?vue&type=script&lang=js"
export * from "./DraftDrugComposer.vue?vue&type=script&lang=js"

import "./DraftDrugComposer.vue?vue&type=style&index=0&id=26480e26&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26480e26"]])

export default __exports__